<div class="faspinner" *ngIf="loading">
  <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
</div>
<div *ngIf="!loading">
  <div style="margin: 1rem;">
    <div id="form-container">
      <form (submit)="onFormSubmit($event)">
        <dx-form    id="form" [(formData)]="personalsettingform" labelMode="floating" labelLocation="top"
          [showColonAfterLabel]="true" [showValidationSummary]="true" validationGroup="customerData"
         >
          <dxi-item itemType="group" [colCount]="12">
            <dxi-item [colSpan]="4" dataField="nameAr">
              <dxo-label text="{{'tableinfo.name'|translate}}"></dxo-label>
              <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}"></dxi-validation-rule>
              <dxi-validation-rule type="async" message="{{'errors.token'|translate}} !!"
                [validationCallback]="validateAsync">
              </dxi-validation-rule>
            </dxi-item>

            <dxi-item [colSpan]="4" dataField="fromAge" editorType="dxNumberBox">
              <dxo-label text="{{'HolidayWorkSystem.fromAge'|translate}}"></dxo-label>
              <dxi-validation-rule type="required" message="{{'errors.required'|translate}}"></dxi-validation-rule>
              <dxi-validation-rule type="range" [min]="0" message="{{'errors.min'|translate}}"></dxi-validation-rule>
            </dxi-item>

            <dxi-item [colSpan]="4" dataField="toAge" editorType="dxNumberBox">
              <dxo-label text="{{'HolidayWorkSystem.toAge'|translate}}"></dxo-label>
              <dxi-validation-rule type="required" message="{{'errors.required'|translate}}"></dxi-validation-rule>
              <dxi-validation-rule type="range" [min]="(personalsettingform?.fromAge)? personalsettingform?.fromAge :0"
                message="{{'errors.greater'|translate}}"></dxi-validation-rule>

            </dxi-item>


            <dxi-item [colSpan]="4" dataField="countDay" editorType="dxNumberBox">
              <dxo-label text="{{'HolidayWorkSystem.countDay'|translate}}"></dxo-label>
              <dxi-validation-rule type="required" message="{{'errors.required'|translate}}"></dxi-validation-rule>
              <dxi-validation-rule type="range" [min]="0" message="{{'errors.min'|translate}}"></dxi-validation-rule>
            </dxi-item>
          </dxi-item>

          <dxi-item>
            <h6 style="margin:10px 0px;" class="text-center">{{'worksystem.holidaytab.title'|translate}}</h6>
            <dx-data-grid [dataSource]="holidayList" [showBorders]="false" (onRowInserting)="onInsertedHoliday($event)"
              (onRowRemoved)="onRemovedHoliday($event)" (onInitNewRow)="onInitNewRowHoiday($event)"
              [columnAutoWidth]="true" [columnHidingEnabled]="true" [showColumnLines]="false"
              [rowAlternationEnabled]="true" [showRowLines]="false" [showBorders]="false" [errorRowEnabled]="false"
              [rtlEnabled]="currentLang=='ar'?true:false" style="margin: 1rem 0rem">
              <dxo-paging [pageSize]="3"> </dxo-paging>
              <dxo-editing mode="row" [allowUpdating]="false" [allowAdding]="true" [allowDeleting]="true"
                [texts]="button">
                <dxo-texts [addRow]="addrowfun('worksystem.holidaytab.title')"
                confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
              </dxo-texts>
              </dxo-editing>

              <dxi-column dataField="holidayTypeId" caption="{{'worksystem.holidaytab.Holidaytype'|translate}}"
                [width]="125" [setCellValue]="setCellValueHoliday">
                <dxo-lookup [dataSource]="holidaydropdown" displayExpr="nameAr" valueExpr="id">
                </dxo-lookup>
                <dxi-validation-rule type="required" message="{{'errors.required'|translate}}"></dxi-validation-rule>
              </dxi-column>
              <dxi-column dataField="holidayNumber" caption="{{'worksystem.holidaytab.Holidaycount'|translate}}"
                [allowEditing]="false">
                <dxi-validation-rule type="range" [min]="0" message="{{'errors.min'|translate}}"></dxi-validation-rule>
                <dxi-validation-rule type="required" message="{{'errors.required'|translate}}"></dxi-validation-rule>
              </dxi-column>
            </dx-data-grid>
          </dxi-item>
          <dxi-item itemType="button" stylingMode="outlined" horizontalAlignment="right"
            [buttonOptions]="buttonOptions" [editorOptions]="{disabled:holidayList.length <= 0}">
          </dxi-item>
        </dx-form>
      </form>
      <ng-container *ngIf="holidayData?.holidaySystemDetails?.length > 0">
        <app-detail-grid [data]="holidayData.holidaySystemDetails"></app-detail-grid>
      </ng-container>

    </div>
    <dx-button stylingMode="outlined" text="{{'employeeduration.submit'|translate}}" type="default"
      (onClick)="SubmitData($event)" style="margin: 1rem;
        width: 10rem;
        display: flex;
        float: left;" [visible]="holidayData?.holidaySystemDetails?.length > 0">
    </dx-button>
  </div>

</div>